import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const MOBILE_BREAKPOINT = 769;

export default function TopBar({ user, firstName, handleLogout }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);
  const moreRef = useRef(null);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  // Close "More" dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (moreRef.current && !moreRef.current.contains(e.target)) {
        setMoreOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleNav = (path) => {
    navigate(path);
    setMenuOpen(false);
    setMoreOpen(false);
  };

  return (
    <>
      <header style={styles.header}>
        <nav style={styles.nav}>
          {/* Logo */}
          <div onClick={() => navigate("/")} style={styles.logoWrap}>
            <img src="/favicon/android-chrome-192x192.png" alt="Ocul" style={styles.logoImg} />
          </div>


          {/* Desktop right side */}
          {/* Desktop nav */}
          {!isMobile && (
            <div style={styles.desktopRight}>
              {/* More dropdown */}
              <div ref={moreRef} style={styles.moreWrap}>
                <button
                  onClick={() => setMoreOpen(!moreOpen)}
                  style={{
                    ...styles.navLink,
                    color: moreOpen ? "#F59E0B" : "#555",
                  }}
                >
                  More
                  <svg
                    width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                    style={{
                      marginLeft: 4,
                      transition: "transform 0.2s",
                      transform: moreOpen ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  >
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </button>
                {moreOpen && (
                  <div style={styles.moreDropdown}>
                    <button onClick={() => handleNav("/pricing")} style={styles.moreItem}>Pricing & Refund</button>
                    <button onClick={() => handleNav("/privacy")} style={styles.moreItem}>Privacy Policy</button>
                    <button onClick={() => handleNav("/terms")} style={styles.moreItem}>Terms of Service</button>
                  </div>
                )}
              </div>

              {/* About */}
              <button onClick={() => navigate("/home")} style={styles.navLink}>Home</button>

              {/* Divider */}
              <div style={{ width: 1, height: 20, background: "#e5e5e5", margin: "0 8px" }} />

              {/* User / Auth */}
              {user ? (
                <div style={styles.profileWrap}>
                  <button onClick={() => setProfileOpen(!profileOpen)} style={styles.avatarBtn}>
                    <span style={styles.avatarText}>{firstName?.charAt(0)?.toUpperCase() || "?"}</span>
                  </button>
                  {profileOpen && (
                    <>
                      <div style={styles.profileBackdrop} onClick={() => setProfileOpen(false)} />
                      <div style={styles.profileDropdown}>
                        <div style={styles.profileHeader}>
                          <div style={styles.profileAvatarLg}>{firstName?.charAt(0)?.toUpperCase()}</div>
                          <div style={styles.profileName}>{firstName}</div>
                        </div>
                        <div style={styles.profileDivider} />
                        <button onClick={handleLogout} style={styles.logoutBtn}>
                          <LogoutIcon />
                          Log out
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <div style={styles.authBtns}>
                  <button onClick={() => navigate("/login")} style={styles.signInBtn}>Sign in</button>
                  <button onClick={() => navigate("/signup")} style={styles.signUpBtn}>Sign up</button>
                </div>
              )}
            </div>
          )}

          {/* Mobile hamburger */}
          {isMobile && (
            <button
              style={styles.hamburger}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              {menuOpen ? (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="2" strokeLinecap="round">
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              ) : (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="2" strokeLinecap="round">
                  <path d="M4 7h16M4 12h16M4 17h16" />
                </svg>
              )}
            </button>
          )}
        </nav>
      </header>

      {/* Mobile backdrop */}
      {menuOpen && (
        <div style={styles.mobileBackdrop} onClick={() => setMenuOpen(false)} />
      )}

      {/* Mobile drawer */}
      <div
        style={{
          ...styles.mobileDrawer,
          transform: menuOpen ? "translateX(0)" : "translateX(100%)",
        }}
      >
        <div style={styles.drawerContent}>
          <div style={styles.drawerSection}>
            <div style={styles.drawerLabel}>Menu</div>
            <button onClick={() => handleNav("/home")} style={styles.drawerLink}>Home</button>
          </div>

          <div style={styles.drawerDivider} />

          <div style={styles.drawerSection}>
            <div style={styles.drawerLabel}>More</div>
            <button onClick={() => handleNav("/pricing")} style={styles.drawerLink}>Pricing & Refund</button>
            <button onClick={() => handleNav("/privacy")} style={styles.drawerLink}>Privacy Policy</button>
            <button onClick={() => handleNav("/terms")} style={styles.drawerLink}>Terms of Service</button>
          </div>

          <div style={styles.drawerDivider} />

          <div style={styles.drawerBottom}>
            {user ? (
              <>
                <div style={styles.drawerProfile}>
                  <div style={styles.drawerAvatar}>
                    {firstName?.charAt(0)?.toUpperCase()}
                  </div>
                  <span style={styles.drawerName}>{firstName}</span>
                </div>
                <button onClick={handleLogout} style={styles.drawerLogout}>
                  Log out
                </button>
              </>
            ) : (
              <>
                <button onClick={() => handleNav("/login")} style={styles.drawerSignIn}>
                  Sign in
                </button>
                <button onClick={() => handleNav("/signup")} style={styles.drawerSignUp}>
                  Sign up
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

const LogoutIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const styles = {
  header: {
    position: "sticky",
    top: 0,
    zIndex: 50,
    width: "100%",
    background: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    borderBottom: "1px solid #f0f0f0",
  },
  nav: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    maxWidth: 1120,
    margin: "0 auto",
    padding: "12px 20px",
  },

  logoWrap: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
    userSelect: "none",
  },
  logoImg: {
    width: 28,
    height: 28,
    objectFit: "contain",
    borderRadius: 4,
  },
  logoText: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 25,
    fontWeight: 800,
    color: "#1a1a1a",
    letterSpacing: "-0.02em",
  },

  desktopLinks: {
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
  navLink: {
    background: "none",
    border: "none",
    fontFamily: "'Nunito', sans-serif",
    fontSize: 14,
    fontWeight: 700,
    color: "#555",
    cursor: "pointer",
    padding: "6px 14px",
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    transition: "color 0.15s",
  },

  // More dropdown
  moreWrap: {
    position: "relative",
  },
  moreDropdown: {
    position: "absolute",
    top: "calc(100% + 8px)",
    left: 0,
    width: 200,
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 8px 32px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.05)",
    border: "1px solid #f0f0f0",
    padding: "6px",
    zIndex: 60,
  },
  moreItem: {
    display: "block",
    width: "100%",
    textAlign: "left",
    background: "none",
    border: "none",
    fontFamily: "'Nunito', sans-serif",
    fontSize: 13,
    fontWeight: 600,
    color: "#444",
    padding: "9px 12px",
    borderRadius: 8,
    cursor: "pointer",
    transition: "background 0.12s",
  },

  desktopRight: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },

  profileWrap: {
    position: "relative",
  },
  avatarBtn: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    border: "2px solid #FDE68A",
    background: "linear-gradient(135deg, #FEF3C7, #FDE68A)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    transition: "box-shadow 0.15s",
  },
  avatarText: {
    fontFamily: "'Nunito', sans-serif",
    fontSize: 14,
    fontWeight: 800,
    color: "#92400E",
  },
  profileBackdrop: {
    position: "fixed",
    inset: 0,
    zIndex: 40,
  },
  profileDropdown: {
    position: "absolute",
    top: "calc(100% + 8px)",
    right: 0,
    width: 220,
    background: "#fff",
    borderRadius: 14,
    boxShadow: "0 8px 32px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.05)",
    border: "1px solid #f0f0f0",
    padding: 8,
    zIndex: 50,
  },
  profileHeader: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "8px 8px 4px",
  },
  profileAvatarLg: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #FEF3C7, #FDE68A)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'Nunito', sans-serif",
    fontSize: 15,
    fontWeight: 800,
    color: "#92400E",
    flexShrink: 0,
  },
  profileName: {
    fontFamily: "'Nunito', sans-serif",
    fontSize: 14,
    fontWeight: 800,
    color: "#1a1a1a",
  },
  profileDivider: {
    height: 1,
    background: "#f0f0f0",
    margin: "8px 0",
  },
  logoutBtn: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    width: "100%",
    background: "none",
    border: "none",
    fontFamily: "'Nunito', sans-serif",
    fontSize: 13,
    fontWeight: 700,
    color: "#666",
    cursor: "pointer",
    padding: "8px",
    borderRadius: 8,
    transition: "background 0.12s",
  },

  authBtns: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  signInBtn: {
    background: "none",
    border: "none",
    fontFamily: "'Nunito', sans-serif",
    fontSize: 13,
    fontWeight: 700,
    color: "#555",
    cursor: "pointer",
    padding: "6px 14px",
    borderRadius: 10,
  },
  signUpBtn: {
    background: "linear-gradient(135deg, #FBBF24, #F59E0B)",
    color: "#fff",
    border: "none",
    fontFamily: "'Nunito', sans-serif",
    fontSize: 13,
    fontWeight: 800,
    padding: "8px 20px",
    borderRadius: 20,
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(245,158,11,0.3)",
    transition: "transform 0.12s",
  },

  hamburger: {
    background: "none",
    border: "none",
    padding: 6,
    borderRadius: 8,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  mobileBackdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.2)",
    zIndex: 60,
  },
  mobileDrawer: {
    position: "fixed",
    top: 0,
    right: 0,
    width: 280,
    height: "100vh",
    background: "#fff",
    boxShadow: "-8px 0 32px rgba(0,0,0,0.08)",
    zIndex: 70,
    transition: "transform 0.3s ease",
  },
  drawerContent: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: "24px 20px",
  },
  drawerSection: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    paddingTop: 16,
  },
  drawerLabel: {
    fontFamily: "'Nunito', sans-serif",
    fontSize: 10,
    fontWeight: 800,
    color: "#bbb",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    marginBottom: 8,
  },
  drawerLink: {
    background: "none",
    border: "none",
    fontFamily: "'Nunito', sans-serif",
    fontSize: 15,
    fontWeight: 700,
    color: "#333",
    cursor: "pointer",
    textAlign: "left",
    padding: "10px 12px",
    borderRadius: 10,
  },
  drawerDivider: {
    height: 1,
    background: "#f0f0f0",
    margin: "16px 0",
  },
  drawerBottom: {
    marginTop: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  drawerProfile: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 4,
  },
  drawerAvatar: {
    width: 38,
    height: 38,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #FEF3C7, #FDE68A)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'Nunito', sans-serif",
    fontSize: 15,
    fontWeight: 800,
    color: "#92400E",
  },
  drawerName: {
    fontFamily: "'Nunito', sans-serif",
    fontSize: 16,
    fontWeight: 800,
    color: "#1a1a1a",
  },
  drawerLogout: {
    width: "100%",
    background: "#f5f5f5",
    border: "none",
    fontFamily: "'Nunito', sans-serif",
    fontSize: 14,
    fontWeight: 700,
    color: "#555",
    padding: "12px",
    borderRadius: 12,
    cursor: "pointer",
  },
  drawerSignIn: {
    width: "100%",
    background: "none",
    border: "1.5px solid #e5e5e5",
    fontFamily: "'Nunito', sans-serif",
    fontSize: 14,
    fontWeight: 700,
    color: "#444",
    padding: "12px",
    borderRadius: 12,
    cursor: "pointer",
  },
  drawerSignUp: {
    width: "100%",
    background: "linear-gradient(135deg, #FBBF24, #F59E0B)",
    border: "none",
    fontFamily: "'Nunito', sans-serif",
    fontSize: 14,
    fontWeight: 800,
    color: "#fff",
    padding: "12px",
    borderRadius: 12,
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(245,158,11,0.3)",
  },
};